import { Button } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RESET_FORM_VALUES, RESET_TOOTH_SELECTIONS } from '../../../store/DiffRetainers/actionType';
import { Base_Retainer_Request_Err } from '../../../store/NewPatient/utils';
import { useLang } from '../../../util/lang';
const PrescriptionBtnGroup = ({
    handleSubmit,
    onSubmit,
    expanded,
    setExpanded,
    impressionType,
    setImpressionType,
    reset,
    formValues,
    onError,
    isNewCase = false,
    resetAddOnFields,
    errors,
}) => {
    const getConst = useLang();
    const dispatch = useDispatch();
    const diffRetainer = useSelector((state) => state.diffRetainer);
    const { prescriptionFormValues } = diffRetainer;
    return (
        <div>
            {!isNewCase && (
                <Button
                    style={{
                        color: impressionType && 'white',
                        backgroundColor: impressionType && '#593687',
                    }}
                    onClick={handleSubmit(onSubmit, (err) => {
                        onError(err);
                        if (!expanded) {
                            if (Object.keys(err).length > 0) {
                                const fieldName = Object.keys(err)[0];
                                let targetExpand = 'panel1';
                                const isUpperAndLower = fieldName.startsWith('Upper') || fieldName.startsWith('Lower');
                                if (isUpperAndLower) {
                                    targetExpand = fieldName.startsWith('Upper') ? 'Upper' : 'Lower';
                                }
                                setExpanded(targetExpand);
                            }
                        }
                    })}
                    variant="contained"
                    disabled={!impressionType}
                >
                    {getConst(':const.submit')}
                </Button>
            )}
            <Button
                onClick={() => {
                    reset();
                    setImpressionType(undefined);
                    if (isNewCase) {
                        // for reset the stored form values in store
                        // for new case
                        dispatch({ type: RESET_FORM_VALUES });
                        dispatch({ type: RESET_TOOTH_SELECTIONS });
                        dispatch({ type: 'NEW_PATIENT_RESET_RETAINER_REQUEST' });
                        dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: Base_Retainer_Request_Err });
                    }
                    if (resetAddOnFields && typeof resetAddOnFields === 'function') {
                        resetAddOnFields();
                    }
                }}
                variant="contained"
            >
                {getConst(':const.reset')}
            </Button>
            {/* <Button onClick={() => console.log(formValues)} variant="contained">
            Log
            </Button> */}
            {/* <Button onClick={async () =>  {
                const validate = diffRetainer.targetTypeRetainerValidationFunc
                const isValid = await validate()
                console.log("isValid => ", isValid)
                console.log("formValues => ", formValues)
                console.log('errors => ', errors)
            }} variant="contained">
            Validate form
            </Button> */}
        </div>
    );
};

export default PrescriptionBtnGroup;
